import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout } from "./actions/securityActions";
import LOGO from './logo.png'
class Header extends Component {

  logout() {
    this.props.logout();
    window.location.href = "/";
  }
  render() {
    const { validToken, user } = this.props.security;
    // const isAccounts = validToken && user.roles.includes("ROLE_ACCOUNTS");
    // const isMembership = validToken && user.roles.includes("ROLE_MEMBERSHIP");
    const isAdmin = validToken && user.roles.includes("ROLE_ADMIN");
    // const isSuper = validToken && user.roles.includes("ROLE_SUPER");


    const userIsNotAuthenticated = (
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="nav ml-auto nav-pills">
          <li className="nav-item">
            <Link className="nav-link" to="/new-member">
              <i className="fa fa-user-plus pr-1">Add member</i>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/signup">
              <i className="fa fa-user-plus pr-1"> Sign Up</i>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/login">
              <i className="fa fa-sign-in-alt pr-1"> Sign In</i>
            </Link>
          </li>
        </ul>
      </div>
    );

    const userIsAuthenticated = (
      <div className="collapse navbar-collapse" id="navbarNavDropdown">
        <ul className="navbar-nav">
          <li className="nav-item active">
            <Link className="nav-link" to="/">
              Dashboard <span className="sr-only">(current)</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/member-list">
              Membership
            </Link>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Accounts
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <Link className="nav-link" to="/batch-list">
                Receipt Batches
              </Link>
              <Link className="nav-link" to="/process-account">
                Receipting/Billing
              </Link>

            </div>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Reports
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <Link className="dropdown-item" to="/accounts-report">
                Financial Reports
              </Link>

              <Link className="dropdown-item" to="/membership-report">
                Membership Reports
              </Link>
            </div>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Setup
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >

              <Link className="dropdown-item" to="/sector-list">
                Sectors
              </Link>
              <Link className="dropdown-item" to="/site-list">
                Sites
              </Link>
              <Link className="dropdown-item" to="/branch-list">
                Branches
              </Link>
              <Link className="dropdown-item" to="/institution-list">
                Institutions
              </Link>
              <Link className="dropdown-item" to="/grade-list">
                Grades
              </Link>
              <Link className="dropdown-item" to="/exchangeRate-list">
                Exchange Rates
              </Link>

            </div>
          </li>
        </ul>

        <ul className="nav ml-auto nav-pills">
          <li className="nav-item dropdown ">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-user-circle mr-1" />
              {user != null ? user.fullName : ""}
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              {isAdmin && (<Link className="dropdown-item" to="/tradeUnion-list">
                <i className="fa fa-cogs pr-1"> Settings</i>
              </Link>
              )}
              <Link
                className="dropdown-item"
                to="/"
                onClick={this.logout.bind(this)}
              >
                <i className="fa fa-sign-out-alt pr-1">Logout</i>
              </Link>

            </div>
          </li>


        </ul>

      </div>

    );

    let headerLinks;

    if (validToken && user) {
      headerLinks = userIsAuthenticated;
    } else {
      headerLinks = userIsNotAuthenticated;
    }


    return (

      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <a className="navbar-brand" href="#">
          {user != null && <img src={LOGO} alt="Logo" width="70px" height="50px" />}
          {(user != null && user.tradeUnion) ? user.tradeUnion.abbreviation : "SinTaks Systems"}
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        {headerLinks}
      </nav>
    );
  }
}
Header.propTypes = {
  logout: PropTypes.func.isRequired,
  security: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  security: state.security,
});

export default connect(mapStateToProps, { logout })(Header);

